export enum NoteType {
  CreationNote = 'CREATION_NOTE',
  AddNote = 'ADD_NOTE',
  ApproveNote = 'APPROVE_NOTE',
  DeclineNote = 'DECLINE_NOTE',
  CancelNote = 'CANCEL_NOTE',
  CommentNote = 'ADD_COMMENT',
}
